jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Account menu
  //############################################//

  const mq = window.matchMedia('(min-width: 992px)');
  if (mq.matches) {
    //Add is-active to first item in dropdown menu
    $('.c-account-menu').removeClass('active');
    $('.js-site-header__account-link').on('click', function () {
      $('body').addClass('overflow-hidden');
      $(this)
        .parent()
        .next('.c-account-menu')
        .addClass('active')
        .removeClass('inactive start');
    });

    $('.js-account-menu-close').on('click', function () {
      $(this).parent().removeClass('active');
      $('.c-account-menu').addClass('inactive');
      $('body').removeClass('overflow-hidden');
    });

    // change add to basket Text
    $('.c-account-menu').find('.add_to_cart_button.ajax_add_to_cart').text('Add');
  }
});
